module.exports = __webpack_public_path__ + "img/JoyHolidayGift.77b0bbe9.png";